import { useId, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { sportLabel } from "../../lib/labels";
import { DIRECTORY_SPORTS, directorySearchPath } from "./useTournamentDirectory";
import "./SearchBar.css";

/** Buscador del inicio: lleva a /torneos?q=…&deporte=… (la página de torneos
 * lee esos parámetros y filtra). */
export function SearchBar({ className = "" }: { className?: string }) {
  const navigate = useNavigate();
  const id = useId();
  const [query, setQuery] = useState("");
  const [sport, setSport] = useState("");

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    navigate(directorySearchPath(query, sport));
  }

  return (
    <form role="search" className={`t123-searchbar ${className}`.trim()} onSubmit={handleSubmit}>
      <div className="t123-searchbar__field t123-searchbar__field--query">
        <label className="t123-sr-only" htmlFor={`${id}-q`}>
          Buscar torneo
        </label>
        <SearchIcon />
        <input
          id={`${id}-q`}
          type="search"
          name="q"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Torneo, sede u organizador"
          autoComplete="off"
          enterKeyHint="search"
          maxLength={120}
        />
      </div>
      <div className="t123-searchbar__field t123-searchbar__field--sport">
        <label className="t123-sr-only" htmlFor={`${id}-sport`}>
          Deporte
        </label>
        <select id={`${id}-sport`} name="deporte" value={sport} onChange={(event) => setSport(event.target.value)}>
          <option value="">Todos los deportes</option>
          {DIRECTORY_SPORTS.map((key) => (
            <option key={key} value={key}>
              {sportLabel(key)}
            </option>
          ))}
        </select>
        <ChevronIcon />
      </div>
      <button type="submit" className="t123-btn t123-btn--primary t123-searchbar__submit">
        Buscar
      </button>
    </form>
  );
}

function SearchIcon() {
  return (
    <svg className="t123-searchbar__icon" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.6-3.6" />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg className="t123-searchbar__chevron" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}
